export const templateQuestions = ({ t, lng }) => [
  {
    question: t("Wie viel Erfahrung hast Du diesem Bereich?", { lng }),
    key: "Berufserfahrung",
    formality: "Du",
    selections: [
      {
        text: t("< 1 year", { lng }),
        isDisqualifying: true
      },
      {
        text: t("1 - 3 years", { lng }),
        isDisqualifying: false
      }
    ]
  },
  {
    question: t("Welchen Abschluss hast Du?", { lng }),
    key: "Abschluss",
    formality: "Du",
    selections: []
  },
  {
    question: "",
    key: "Kenntnisse",
    formality: "Du",
    selections: []
  },
  {
    question: "",
    key: "Custom",
    formality: "Du",
    selections: []
  },
  {
    question: t("Wie viel Erfahrung haben Sie diesem Bereich?", { lng }),
    key: "Berufserfahrung",
    formality: "Sie",
    selections: [
      {
        text: t("< 1 year", { lng }),
        isDisqualifying: true
      },
      {
        text: t("1 - 3 years", { lng }),
        isDisqualifying: false
      }
    ]
  },
  {
    question: t("Welchen Abschluss haben Sie?", { lng }),
    key: "Abschluss",
    formality: "Sie",
    selections: []
  },
  {
    question: "",
    key: "Kenntnisse",
    formality: "Sie",
    selections: []
  },
  {
    question: "",
    key: "Custom",
    formality: "Sie",
    selections: []
  }
];
